import React, { useState, useEffect, useMemo } from "react"
import axios from "axios";
import {useTranslation} from "react-i18next";
import i18next from "i18next";

function MembershipBarSection(props) {
    const {t, i18n} = useTranslation('common');

    useEffect(() => {
        if( props?.lan == 'en' ) {
            i18next.changeLanguage("en");
        }else{
            i18next.changeLanguage("el");
        }
    }, []);
    function set_url(path) {
        return props?.site_url+path;
    }
    return (<section class="member-section rem_membershection_bar">
          
        <div class="container_size">
            <ul class="membership_number">
                {(props?.MetaData?.membership_number) ?
                    <li class="member-id exprience_list">
                        <div><img src={set_url("/wp-content/uploads/images/user.svg")} /></div>
                        <div>
                            <p>{t('Membership Number')}</p>
                            <h5>{(props?.MetaData?.membership_number) ? props?.MetaData?.membership_number : ''}</h5>
                        </div>
                    </li>
                    : ''
                }

                <li class="member-id ">
                    <div><img src={set_url("/wp-content/uploads/images/Shield.svg")} /></div>
                    <div>
                        <h5>{t('1 YEAR')}<br /> {t('MEMBER')}</h5>
                    </div>
                </li>

                <li class="member-id member-id-2">
                    <div>
                        <p><b>{t('Do not forget.')}</b> {t('Please mention Tamastoria when you contact our trusted craftsmen.')}</p>
                    </div>
                </li>

            </ul>
        </div>
    </section>);
}

export default MembershipBarSection;